import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Login from './pages/Login';
import FieldMappings from './pages/FieldMappings';
import LenderMatch from './pages/LenderMatch';
import LenderSettings from './pages/LenderSettings';
import OpportunitySearch from './pages/OpportunitySearch';
import OpportunityDetail from './pages/OpportunityDetail';
import { AuthProvider } from './context/AuthContext';
import { ValidationProvider } from './context/ValidationContext';
import { NotificationProvider } from './context/NotificationContext';
import ToastContainer from './components/notifications/ToastContainer';
import { ProtectedRoute, AdminRoute } from './components/auth';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './styles/transitions.css';
import './styles/validation.css';
import './styles/Notifications.css';

/**
 * AnimatedRoutes component to handle page transitions
 * Uses React Router and CSSTransition for smooth page navigation
 * @returns {JSX.Element} The animated routes component
 */
const AnimatedRoutes = () => {
  const location = useLocation();
  
  return (
    <>
      <TransitionGroup>
        <CSSTransition
          key={location.pathname}
          timeout={400}
          classNames="page-transition"
          unmountOnExit
        >
          <div className="page-container">
            <Routes location={location}>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={
                <ProtectedRoute>
                  <OpportunitySearch />
                </ProtectedRoute>
              } />
              <Route path="/opportunity/:opportunityId" element={
                <ProtectedRoute>
                  <OpportunityDetail />
                </ProtectedRoute>
              } />
              <Route path="/field-mappings" element={
                <AdminRoute>
                  <FieldMappings />
                </AdminRoute>
              } />
              <Route path="/lender-match" element={
                <AdminRoute>
                  <LenderMatch />
                </AdminRoute>
              } />
              <Route path="/lender-settings" element={
                <AdminRoute>
                  <LenderSettings />
                </AdminRoute>
              } />
            </Routes>
          </div>
        </CSSTransition>
      </TransitionGroup>
    </>
  );
};

/**
 * Main App component that sets up routing and context providers
 * @returns {JSX.Element} The main application
 */
function App() {
  return (
    <Router>
      <AuthProvider>
        <ValidationProvider>
          <NotificationProvider>
            <Navigation />
            <ToastContainer />
            <AnimatedRoutes />
          </NotificationProvider>
        </ValidationProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
